import {
  GET_JOB_POSTS,
  JOB_ERROR,
  DELETE_JOB_POST,
  DELETE_JOB_APPLICATION,
  ADD_JOB_POST,
  GET_JOB_POST,
  CLEAR_APPLICANT,
  CLEAR_JOBS,
  APPLY,
  ACCEPT_APPLICATION,
  DECLINE_APPLICATION,
  REMOVE_APPLICANT,
  GET_APPLIED_JOBS,
} from "../actions/types";

const initialState = {
  jobs: [],
  applied_jobs: [],
  applicant: {},
  applicants: [],
  accepted_applicants: [],
  jobloading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_APPLIED_JOBS:
      return {
        ...state,
        applied_jobs: payload,
        jobloading: false,
      };
    case GET_JOB_POSTS:
      return {
        ...state,
        jobs: payload,
        jobloading: false,
      };
    case GET_JOB_POST:
      return {
        ...state,
        jobs: payload.jobs,
        applicants: payload.applicants,
        accepted_applicants: payload.accepted_applicants,
        jobloading: false,
      };
    case ADD_JOB_POST:
      return {
        ...state,
        job: payload,
        jobloading: false,
      };
    case DELETE_JOB_POST:
      return {
        ...state,
        jobs: state.jobs.filter((job) => job._id !== payload),
        jobloading: false,
      };
    case APPLY:
      return {
        ...state,
        applied_jobs: [...state.applied_jobs, payload],
        loading: true,
      };
    case ACCEPT_APPLICATION:
      return {
        ...state,
        applicants: [
          ...state.applicants.filter((x) => x.email !== payload.email),
        ],
        accepted_applicants: [...state.accepted_applicants, payload],
        loading: true,
      };
    case DECLINE_APPLICATION:
      return {
        ...state,
        applicants: [...state.applicants.filter((x) => x.email !== payload)],
        jobloading: false,
      };
    case JOB_ERROR:
      return {
        ...state,
        error: payload,
        jobloading: false,
      };
    case DELETE_JOB_APPLICATION:
      return {
        ...state,
        applied_jobs: [
          ...state.applied_jobs.filter(
            (x) => x._id.toString() !== payload.toString()
          ),
        ],
        jobloading: false,
      };
    case REMOVE_APPLICANT:
      return {
        ...state,
        accepted_applicants: [
          ...state.accepted_applicants.filter((x) => x.email !== payload),
        ],
        jobloading: false,
      };
    case CLEAR_APPLICANT:
      return {
        ...state,
        applicant: {},
      };
    case CLEAR_JOBS:
      return {
        ...state,
        jobs: [],
        applicant: {},
        jobloading: true,
        error: {},
      };
    default:
      return state;
  }
}
